/**
 * Glass card styling - transparent with blur effect.
 * Used across the app for consistent visual treatment.
 */
export const glassCardStyles =
  "bg-white/[0.02] border-white/[0.08] shadow-none backdrop-blur-sm";
